var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.$style.link,attrs:{"href":_vm.url}},[_c('span',{class:_vm.$style.image,style:(("background-image: url(" + _vm.image + ")"))}),_c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }